import _ from "lodash";
import UserAuth from "@/mixins/UserAuth";

export default {
    mixins: [
        UserAuth,
    ],
    methods: {
        hasPermissionsToRoute(to) {
            const routeTo = this.$router.matcher.match(to);
            return _(routeTo.matched)
                .map(v => v?.meta?.permissionsByModule)
                .filter()
                .every(v => this.user?.permissions?.byModule[v]?.canRead);
        },
    },
}
